import React from 'react';
import styled from 'styled-components';
import { ButtonWhiteNoShadow } from '../../styles/Button';
import { ButtonGray2 } from '../../styles/Button';
import { Clickable } from '../../styles/Animation';
import PremiumLockIcon from '../../common/PremiumLockIcon';
import { TODO_APP_TODOIST, TODOIST_AUTH_URL, } from '../../../constants';
import { useAppSelector, configSelectors, } from '@pomofocus/shared-client';
import { IconSets } from '../../common/IconSets';
import { FormBlock, FlexWrapper, FormHeader, FormHeaderText, SectionWrapper, } from './common';
import { Button } from '../../common/Button';
export function IntegrationConfig({ todolistAppId, isPremium, showUpgradeModal, removeTodolistIntegration, showTodoistDocModal, showWebhookDocModal, openWebhookModal, userId, }) {
    const configObj = useAppSelector(configSelectors.selectConfigObj);
    const handleClickTodoist = () => {
        if (todolistAppId) {
            if (window.confirm('Do you want to remove Todoist integration?')) {
                removeTodolistIntegration(todolistAppId);
            }
            return;
        }
        if (isPremium) {
            window.location.href = `${TODOIST_AUTH_URL}${userId}`;
        }
        else {
            showUpgradeModal();
        }
    };
    const onClickTodoistInfo = () => {
        showTodoistDocModal();
    };
    const onClickWebhookInfo = () => {
        showWebhookDocModal();
    };
    const onClickWebhookAdd = () => {
        if (isPremium || configObj.webhookUri) {
            openWebhookModal();
        }
        else {
            showUpgradeModal();
        }
    };
    return (React.createElement(SectionWrapper, { subHeader: "Integration", SubHeaderIcon: React.createElement(IconSets, { name: "Integration" }) },
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null,
                        "Todoist",
                        React.createElement(InfoTipWrapper, { onClick: onClickTodoistInfo },
                            React.createElement(InfoTip, { src: "/icons/information-black2.png" })))),
                React.createElement(NotificationWrapper, null, todolistAppId === TODO_APP_TODOIST ? (React.createElement(Button, { theme: "flat", size: "small", onClick: handleClickTodoist }, "Connected")) : (React.createElement(Button, { theme: "secondary", size: "small", onClick: handleClickTodoist },
                    "Connect ",
                    React.createElement(PremiumLockIcon, { isPremium: isPremium })))))),
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null,
                        "Webhook",
                        React.createElement(InfoTipWrapper, { onClick: onClickWebhookInfo },
                            React.createElement(InfoTip, { src: "/icons/information-black2.png" })))),
                React.createElement(NotificationWrapper, null, configObj.webhookUri ? (React.createElement(Button, { theme: "flat", size: "small", onClick: onClickWebhookAdd }, "Saved")) : (React.createElement(Button, { theme: "secondary", size: "small", onClick: onClickWebhookAdd },
                    "Add ",
                    React.createElement(PremiumLockIcon, { isPremium: isPremium }))))))));
}
const NotificationWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const TodoistButton = styled(ButtonWhiteNoShadow) ``;
const TodoistButtonConnected = styled(ButtonGray2) ``;
const InfoTipWrapper = styled.div `
  ${Clickable}
  margin-left: 0.5rem;
`;
const InfoTip = styled.img `
  opacity: 0.3;
  width: 1rem;
  height: 1rem;
`;
